import React, { Component, Fragment } from 'react';
import { DIAGNOSIS_DO_NOT_PRINT, SEARCH_DIAGNOSIS, FAVOURITE_DIAGNOSIS, LOADER_BLACK, IMAGE_LIBRARY,APPLY_DIAGNOSIS_SEQUENCE } from '../../utils/constant';
import LS_SERVICE from '../../utils/localStorage';
import { Select, Modal, Button, Tabs, Radio,notification } from 'antd';
import 'antd/dist/antd.css';
import Sketchpad from '../../utils/sketchpad';
import axios from 'axios';
import qs from 'qs';
import icImagereference from '../../assets/images/ic-imagereference.png';
import icDrawing from '../../assets/images/ic-drawing.png';
import icEraser from '../../assets/images/ic-eraser.png';
import icundo from '../../assets/images/ic-undo.png';
import icredo from '../../assets/images/ic-redo.png';
import icbrush from '../../assets/images/ic-brush.png';
import icJpg from '../../assets/images/ic-jpg.png';
import { jQueryLabels, ClearAntList } from '../../utils/jQueryLabels';
import { SortableContainer, SortableElement,sortableHandle } from 'react-sortable-hoc';
// import './forms.scss';
import BootstrapSwitchButton from "bootstrap-switch-button-react";
const { Option } = Select;
const { TabPane } = Tabs;



const DragHandleDiagnosis = sortableHandle(() => (
<div class="btn_sequence cursor-p"></div>))

const SortableDiagnosisItem = SortableElement((props) => {
  return props.renderDiagnosisRow(
    props.data,
    props.index,   
    props.sno      
  );
});
const SortableDiagnosisBody = SortableContainer(({ children }) => {
  return <tbody>{children}</tbody>;
});



class AssessmentTableSS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assessmentData:  props.assessmentData || [],
      viewType: props.viewType || 'full',
      constants: props.constants || [],
      allowEdit:this.props.allowEdit??true,
      sequence_change_updated: true,
      isApplyLoader: false,

    };
    this.applyDiagnosisSequence = this.applyDiagnosisSequence.bind(this);
  }

  componentDidMount() {
    axios.defaults.headers.common["Authorization"] = LS_SERVICE.get('token');
    jQueryLabels();
  }

  componentDidUpdate(prevProps, prevState) {
  if (this.state.sequence_change_updated === true) {
    if (prevProps.assessmentData !== this.props.assessmentData) {
      this.setState({
        assessmentData: this.props.assessmentData,
        viewType: this.props.viewType,
        constants: this.props.constants,
      });
    }
  } else {
    console.log('Blocking props update - user is reordering');
  }
}

  handleModalPopup = (e, popupName, data, type) => {
    e.preventDefault();
    this.setState({
      [popupName]: !this.state[popupName]
    }, () => {

      const { viewDocumentModal } = this.state;

      if (viewDocumentModal) {
        if (data !== null) {
          this.setState({
            docComment: data.image_comment,
            docSrc: (data.image_uploaded && data.image_uploaded != undefined) ? data.image_uploaded : data.image,
            docType: type === 'img' ? 'image/jpeg' : 'application/pdf'
          })
        }
      } else {
        this.setState({
          docSrc: null,
          docComment: '',
          docType: ''
        })
      }

    })
  }

handleEditDelete = (e, modal, data, action, idx) => {
  if (this.props.isPracticing === false) {
    this.props.practiceModal('isPracticingModal');
    return;
  }

  // Find the actual data item by ID instead of using index
  const actualData = action === 'editAssessment' 
    ? this.state.assessmentData.find(item => item.id === data.id)
    : data;

  this.props.handlePopUp(e, modal, action === 'editAssessment' ? actualData : { data: actualData }, action, actualData?.id || idx);
};
 
renderDiagnosisRow = (data, index, sno) => {
const { constants, allowEdit } = this.state;
const viewType = this.props.viewType;
    const deleteIndex = viewType === 'visit-full' ? data.id : index;

    return (
      <tr  key={`diagnosis-${data.id || index}`} id={data.diagnosis_id}>
        {viewType === "soap-full" && (
          <td width="6%" className="text-center fw-medium">
            {sno + 1}
          </td>
        )}

        <td className={viewType === 'copy-to-visit' && !data.selected ? 'text-danger' : null}>
          {(DIAGNOSIS_DO_NOT_PRINT.includes(data.diagnosis_id) === true ||
            !data.icd_code ||
            data.icd_code === "" ||
            data.icd_code == null) &&
            data.diagnosis_notes
            ? data.diagnosis_notes
            : data.description}
        </td>

        <td>
          <span className="text-primary">
            {data.icd_code ?? '-'}
          </span>
        </td>

        {viewType !== 'template' && (
          <>
            <td>
              {data.popupType == 1 && constants.assessmentSide[data.side]
                ? constants.assessmentSide[data.side]
                : '-'}
            </td>

            <td>
              {constants.assessmentStage[data.stage]
                ? constants.assessmentStage[data.stage]
                : '-'}
            </td>

            <td>
              {constants.assessmentType[data.type]
                ? constants.assessmentType[data.type]
                : '-'}
            </td>

            <td>
              <span className="ant_switch_button_sm">
                <BootstrapSwitchButton
                  width={85}
                  height={24}
                  size="xs"
                  checked={data.status === 0 ? true : false}
                  onlabel="Active"
                  offlabel="Cured"
                  onstyle="switch"
                  offstyle="success"
                  onChange={(e) => this.props.statusSwitch(e, index, data)}
                  disabled={!allowEdit}
                />
              </span>
            </td>
          </>
        )}

        <td>
          <pre>
            {(DIAGNOSIS_DO_NOT_PRINT.includes(data.diagnosis_id) === true ||
              !data.icd_code ||
              data.icd_code === "" ||
              data.icd_code == null) &&
              data.diagnosis_notes
              ? '-'
              : data.diagnosis_notes
                ? data.diagnosis_notes
                : '-'}
          </pre>
        </td>

        <td className="image-reference-column">
          {viewType === 'copy-to-visit' &&
            data.image &&
            data.image != null &&
            data.image !== '' ? (
            <img
              src={icJpg}
              alt={data.description}
              title={data.image_comment}
              className={`img-fluid ${data.image === "" ? 'd-none' : ''}`}
              style={{ cursor: 'pointer' }}
              onClick={(e) =>
                this.handleModalPopup(e, 'viewDocumentModal', data, 'img')
              }
            />
          ) : null}

          {viewType !== 'copy-to-visit' &&
            data.image_uploaded &&
            data.image_uploaded != null &&
            data.image_uploaded !== '' ? (
            <img
              src={icJpg}
              alt={data.description}
              title={data.image_comment}
              className={`img-fluid ${data.image_uploaded === "" ? 'd-none' : ''
                }`}
              style={{ cursor: 'pointer' }}
              onClick={(e) =>
                this.handleModalPopup(e, 'viewDocumentModal', data, 'img')
              }
            />
          ) : null}
        </td>

        {this.props.showAction && (
          <td>
            {this.props.viewType === 'template' ? null : this.props.viewType === 'soap-full' ? (
              <a
                className="nostyle-link mr-2"
                onClick={(e) => this.props.handleEdit(data, data.id)}
              >
                <i className="icon-edit"></i>
              </a>
            ) : (
              <a
                className="nostyle-link mr-2"
                onClick={(e) =>
                  this.handleEditDelete(
                    e,
                    'showAssessmentModal',
                    data,
                    'editAssessment',
                    data.id
                  )
                }
              >
                <i className="icon-edit"></i>
              </a>
            )}

            <a
              className="nostyle-link mr-2"
              onClick={(e) =>
                this.handleEditDelete(
                  e,
                  'deleteConfirmModal',
                  data,
                  'deleteAssessment',
                  data.id
                )
              }
            >
              <i className="icon_delete"></i>
            </a>

            {this.props.showSelectCheck && (
              <span className="select-diagnosis select-check">
                <i
                  data-checkSelect={data.id}
                  data-type={'assessment'}
                  onClick={(e) =>
                    this.props.updateSelection(data.id, 'assessmentData')
                  }
                  className={
                    data.selected ? 'btn-true-sm accept' : 'btn-true-sm'
                  }
                ></i>
              </span>
            )}
          </td>
        )}

        {viewType === "soap-full" && this.state.assessmentData.length > 1 && this.props.isDiagnosisSequence && (
          <td width="6%" className="drag-handle-col text-center">
            <DragHandleDiagnosis />
          </td>
        )}
      </tr>
    );
  };

  onSortEndDiagnosis = ({ oldIndex, newIndex }) => {
  
  if (oldIndex === newIndex) return;
  
  const list = [...this.state.assessmentData];
  const [movedItem] = list.splice(oldIndex, 1);
  list.splice(newIndex, 0, movedItem);

  this.setState({
    assessmentData: list,
    sequence_change_updated: false,
  },)
};
applyDiagnosisSequence = async () => {
  this.setState({ isApplyLoader: true });

  try {
    const PARAMS = {
      diagnosis: this.state.assessmentData,
    };

    await axios.post(APPLY_DIAGNOSIS_SEQUENCE, PARAMS);
    this.props.updateData()
    notification.success({
      message: 'Diagnosis Sequence Updated Successfully',
      placement: "topRight",
    });
    
    this.setState({
      isApplyLoader: false,
      sequence_change_updated: true  // Changed from false to true - this hides the button
    });
  } catch (err) {
    console.error("Diagnosis sequence update failed:", err);
    notification.error({
      message: 'Failed to update diagnosis sequence',
      placement: "topRight",
    });
    this.setState({ 
      isApplyLoader: false
    });
  }
};

  render() {
    const { constants, viewType } = this.state;

    return (
      <Fragment>
        {this.state.assessmentData.length > 0 ?
          <>
            <table className="table table-bordered suggested-protocol-table mt-2 mb-1" id="diagnosis-list">
              <thead>
                {this.state.viewType == 'template' ?
                  <tr>
                    <th>Diagnosis</th>
                    <th width="100">ICD 10</th>
                    <th>NOTES</th>
                    <th>IMAGE REFERENCE</th>
                    {this.props.showAction ? <th width="100">Action</th> : null}
                  </tr> :
                  <tr>
                    <th width="7%">S.NO</th>
                    <th width="17%">DIAGNOSIS</th>
                    <th width="9%">ICD 10</th>
                    <th width="8%">SIDE</th>
                    <th width="8%">STAGE</th>
                    <th width="8%">TYPE</th>
                    <th width="7%">STATUS</th>
                    <th width="18%">NOTES</th>
                    <th width="12%">IMAGE REFERENCE</th>
                    {this.props.showAction ? <th width="9%">ACTION</th> : null}
                    {this.state.viewType === "soap-full" && this.state.assessmentData.length > 1 && this.props.isDiagnosisSequence && (
                      <th width="6%" className="text-center">SEQUENCE</th>
                    )}
                  </tr>

                }
              </thead>
              <SortableDiagnosisBody
                helperClass="sortableHelperDSConfig"
                onSortEnd={this.onSortEndDiagnosis}
                lockAxis="y"
                lockToContainerEdges={false}
                useDragHandle
                disableAutoscroll={true}
                helperContainer={() => document.querySelector('#diagnosis-list') || document.body}
              >
                {this.state.assessmentData?.map((data, index) => (
                  <SortableDiagnosisItem
                    key={data.id}  
                    index={index}                       
                    sno={index}
                    data={data}
                    renderDiagnosisRow={this.renderDiagnosisRow}
                  />
                ))}
              </SortableDiagnosisBody>
            </table>
             {this.state.viewType === "soap-full" &&
              this.state.assessmentData.length > 1 &&
              !this.state.sequence_change_updated && (  // Show when false
                <div className="row">
                  <div className="col-12 d-flex justify-content-end">
                    <button
                      className="btn btn-outline-secondary small px-2 mt-1"
                      onClick={this.applyDiagnosisSequence}
                      disabled={this.state.isApplyLoader}
                    >
                      Update Sequence {this.state.isApplyLoader ? <span className="spinner-border spinner-border-sm ml-2" /> : ""}
                    </button>
                  </div>
                </div>
              )}
          </>
          : (null)
        }

        <input type="hidden" name="diagnosis-list-data" id="diagnosis-list-data" />

        <Modal
          title={"Image Reference"}
          visible={this.state.viewDocumentModal}
          footer={false}
          width={850}
          onCancel={e => this.handleModalPopup(e, 'viewDocumentModal')}
          style={{ top: 20 }}
        >
          <div className="pdf_slider">
            <figure><img className="mr-3 w-100" src={this.state.docSrc} alt='uploaded Doc' /></figure>
            <div className="text-center">
              <strong style={{ fontSize: '16px' }}>
                {this.state.docComment}
              </strong>
            </div>
          </div>
        </Modal>

      </Fragment>
    );
  }
}

export default AssessmentTableSS;